import * as React from "react"
import { Fragment } from "react"
import { Menu, Transition } from "@headlessui/react"

export default function Network() {
  const links = [
    {
      href: "https://www.peopleforbikes.org/",
      label: "PeopleForBikes main site",
    },
    { href: "https://cityratings.peopleforbikes.org/", label: "City Ratings" },
    { href: "https://shift.peopleforbikes.org/", label: "SHIFT Conference" },
    {
      href: "https://www.peopleforbikes.org/campaigns",
      label: "View more sites",
    },
  ]

  return (
    <div className="bg-pfb-navy text-white px-4 py-3 text-xs font-bold relative uppercase z-10">
      <Menu>
        <Menu.Button>
          <span className="sm:hidden uppercase">Network of sites</span>
          <span className="hidden sm:inline uppercase">
            Explore our network of sites
          </span>
        </Menu.Button>
        <Transition
          enter="transition duration-100 ease-out"
          enterFrom="transform opacity-0"
          enterTo="transform opacity-100"
          leave="transition duration-75 ease-out"
          leaveFrom="transform opacity-100"
          leaveTo="transform opacity-0"
        >
          <Menu.Items className="bg-pfb-navy absolute flex flex-col py-4 px-5 space-y-4 mt-3 -ml-3 z-20">
            {links.map(link => (
              <Menu.Item key={link.href} as={Fragment}>
                <a
                  href={link.href}
                  target="_blank"
                  rel="noreferrer"
                  className="hover:underline underline-offset-2"
                >
                  {link.label}
                </a>
              </Menu.Item>
            ))}
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  )
}
